<ion-radio-group class="radio-group" (ionChange)="onInputChanged($event)">
    @for (option of options; track option.value) {
        <ion-radio [value]="option.value" labelPlacement="end" justify="start" [disabled]="option.disabled">
            <span class="radio-label body-medium">{{ option.label }}</span>
        </ion-radio>
    }
</ion-radio-group>
